import axios from 'axios';
import { TaxRegimeOption } from '../types/taxRegime'; // Assumindo que o tipo será criado aqui

const API_URL = '/api/tax-regimes';

class TaxRegimeService {
  async getTaxRegimes(): Promise<TaxRegimeOption[]> {
    try {
      const response = await axios.get<TaxRegimeOption[]>(API_URL);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar regimes tributários:", error);
      throw new Error('Falha ao buscar opções de regime tributário.');
    }
  }
}

export default TaxRegimeService; 